import { render } from "./modelMess.vue?vue&type=template&id=3d1955cc"
import script from "./modelMess.vue?vue&type=script&lang=js"
export * from "./modelMess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@5.110.3_clean-css@5.3.3_c_fd8bdb85bb9a93cd57e0f6a421dc3a81/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__